module.exports = __webpack_public_path__ + "3b789d27626f15c29ff96c17e98e4e93.png";